import { themeGet } from '@styled-system/theme-get'
import { Flex } from 'pcln-design-system'
import styled from 'styled-components'

export const PrimaryWrapper = styled(Flex)`
  justify-content: center;
  height: 250px;
  width: 100%;
  margin: 0 16px 0 0;
  max-width: 474px;
  min-width: 300px;
`

export const SecondaryWrapper = styled(Flex)`
  display: none;

  ${themeGet('mediaQueries.xl')} {
    display: block;
    justify-content: center;
    height: 250px;
    width: 100%;
    margin: 0 16px 0 0;
    max-width: 474px;
    min-width: 300px;
  }
`

export const TertiaryWrapper = styled(Flex)`
  height: 250px;
  width: 300px;
`
